<template>
  <div class="promo-edit" v-show="editor.mode == 'editing'">
    <template v-if="parameters.geo">
      <div class="box-edit-line">
        <label class="label-edit">Zone géographique</label>

        <div v-if="parameters.geo.epci">
          <q-radio
            v-model="zoneGeo"
            val="epci"
            label="Agglomération (EPCI)"
            :disabled="
              active_study.qlikData && active_study.qlikData.geo
                ? active_study.qlikData.geo.epci.disable
                : false
            "
            dense
          />
        </div>

        <div v-if="parameters.geo.commune">
          <q-radio
            v-model="zoneGeo"
            val="commune"
            label="Commune"
            :disabled="
              active_study.qlikData && active_study.qlikData.geo
                ? active_study.qlikData.geo.commune.disable
                : false
            "
            dense
          />
        </div>

        <div v-if="parameters.geo.quartiers">
          <q-radio v-model="zoneGeo" val="quartier" label="Quartier" dense />
          <div v-if="zoneGeo == 'quartier'">
            <q-select
              :content-style="{ backgroundColor: '#ff0000' }"
              v-model="zoneGeoQuartier"
              :options="availableQuartiers"
              option-value="code"
              option-label="label"
              emit-value
              map-options
              label="Quartiers"
              option-disable="disable"
              dense
              class="q-mb-sm"
            />
          </div>
        </div>

        <div v-if="parameters.geo.secteurs_adequation">
          <q-radio
            v-model="zoneGeo"
            val="secteurs_adequation"
            label="Secteur Adéquation"
            dense
          />
          <div v-if="zoneGeo == 'secteurs_adequation'">
            <q-select
              :content-style="{ backgroundColor: '#ff0000' }"
              v-model="zoneGeoSecteur"
              :options="availableSecteurs"
              option-value="code"
              option-label="label"
              emit-value
              map-options
              label="Secteurs Adéquation"
              option-disable="disable"
              dense
              class="q-mb-sm"
            />
          </div>
        </div>
      </div>
    </template>

    <div v-if="parameters.periods" class="box-edit-line">
      <label class="label-edit">Trimestre de référence</label>

      <div v-for="t in trimestres" :key="t">
        <q-radio v-model="lastYearPeriod" :val="t" :label="t.toUpperCase()" dense />
      </div>
    </div>


    <div v-if="theme == 'marche_promotion_immobiliere'" class="box-edit-line">
      <button @click="toggleShowChart()">{{textButtonChart}} le graphique "volume prix"</button>
    </div>


    <div v-if="(theme == 'dynamique_marche_residentiel_locatif' || theme == 'marche_locatif') && (active_study.segment.code != 'GIE')" class="box-edit-line">
      <label class="label-edit">Types de logements recensés</label>

      <div>
        <q-radio
          v-model="typeLogement"
          val="logement_neuf"
          label="Logements neufs"
          dense
        />
      </div>
      <div>
        <q-radio
          v-model="typeLogement"
          val="logement_recent"
          label="Logements récents"
          dense
        />
      </div>
      <div>
        <q-radio
          v-model="typeLogement"
          val="logement_ancien"
          label="Logements anciens en bon état"
          dense
        />
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import { mapGetters } from "vuex";
import getParameter from "@/libs/get_parameter.js";

export default {
	mixins: [ElementMixin],
	props: {
		theme: {
			type: String,
			required: true,
		},
		showChart: {
			type: Boolean,
			default: undefined,
		},
	},
	watch: {
		zoneGeo: function (newValue){
			if(newValue=="quartier" && typeof this.etude_data.parameters.marche_promotion_immobiliere.zoneGeoQuartier=="undefined"){
				this.$store.dispatch("edit_object", {
					obj: this.etude_data.parameters.marche_promotion_immobiliere,
					field: "zoneGeoQuartier",
					value: this.zoneGeoQuartier.code,
				});
				this.$store.dispatch("save_study");
				this.$emit("change", zoneGeoQuartier, this.zoneGeoQuartier.code);
			}
			else if (newValue=="secteurs_adequation" && typeof this.etude_data.parameters.marche_promotion_immobiliere.zoneGeoSecteur=="undefined"){
				this.$store.dispatch("edit_object", {
					obj: this.etude_data.parameters.marche_promotion_immobiliere,
					field: "zoneGeoSecteur",
					value: this.zoneGeoSecteur.code,
				});
				this.$store.dispatch("save_study");
				this.$emit("change", zoneGeoSecteur, this.zoneGeoSecteur.code);
			}
		}
	},
	computed: {
		...mapGetters(["etude_data"]),
		textButtonChart (){
			return this.showChart ? "Cacher" : "Afficher";
		},
		parameters () {
			try {
				const parametersPromo =
          this.active_study.qlikData.parameters.editmode.find((editmode) => {return editmode.theme == this.theme;});
				return parametersPromo;
			} catch (e) {
				return false;
			}
		},
		zoneGeo: {
			get () {
				return this.getParameter("zoneGeo", this.parameters.geo.default);
			},
			set (value) {
				this.setParameter("zoneGeo", value);
			},
		},
		zoneGeoQuartier: {
			get () {
				return this.getParameter("zoneGeoQuartier", this.availableQuartiers.length ? this.availableQuartiers[0] : null);
			},
			set (value) {
				this.setParameter("zoneGeoQuartier", value);
			},
		},
		zoneGeoSecteur: {
			get () {
				return this.getParameter("zoneGeoSecteur", this.availableSecteurs.length ? this.availableSecteurs[0] : null);
			},
			set (value) {
				this.setParameter("zoneGeoSecteur", value);
			},
		},
		lastYearPeriod: {
			get () {
				return this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code);
			},
			set (value) {
				this.setParameter("lastYearPeriod", value);
			},
		},
		typeLogement: {
			get () {
				return this.getParameter("typeLogement", null);
			},
			set (value) {
				this.setParameter("typeLogement", value);
			},
		},
		availableQuartiers: function () {
			return this.active_study.qlikData.geo.quartiers;
		},
		availableSecteurs: function () {
			return this.active_study.qlikData.geo.secteurs_adequation;
		},
		trimestres () {
			try {
				return this.parameters.periods.values.map((value) => value.code).sort();
			} catch (e) {
				console.warn(`Error in Trimestre of el-edit-mode, theme ${this.theme}`, e);
				return false;
			}
		},
	},
	methods: {
		toggleShowChart (){
			this.$emit("toggleShowChart");
		},
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.theme, name, defaultValue);
		},
		setParameter (name, value) {
			try {
				this.$store.dispatch("edit_object", {
					obj: this.etude_data.parameters,
					field: `${this.theme}.${name}`,
					value: value,
				});

				this.$emit("change", name, value);
			} catch (e) {
				console.error("Couldn't set parameter", e);
			}
		},
	},
};
</script>

<style lang="stylus">
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.promo-edit {
  position: absolute;
  top: 0;
  right: 780px;
  width: 200px;
  background-color: lighten(purple, 85%);
  box-shadow: 0 0 0 2px #ddd;
  z-index: 0;

  .label-edit{
    display inline-block
    text-transform uppercase
    font-size 10px
    font-weight 500
  }
      

  @media screen and (min-width: 1600px) {
    width 240px
}

  &:after {
    content: '';
    position: absolute;
    left: -8px;
    top: 24px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 0 8px 8px;
    border-color: transparent #ddd transparent transparent;
  }

  .box-edit-line {
    padding: 8px 16px;
    border-bottom: 1px solid #eee;
    text-align: left;

    .q-radio {
      margin-bottom 5px
    }

    .q-field__control-container {
      font-size 12px
    }
  }
}
</style>

<style lang="stylus">
.q-select {
  .q-field__inner, .q-field__control-container {
    flex: 10000 1 0% !important;
  }
}
</style>